/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../bbqualifier/verification_service';
import '../bbqualifier/eligibility_service';
import '../common/location';
import './obligations/obligations';
import '../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "authz_engines": {
        "nested": {
          "PolicyProtectedAction": {
            "values": {
              "ACTION_UNSPECIFIED": 0,
              "LINK_DEBIT_CARD": 1,
              "CREATE_SQUARE_CHECKING_ACCOUNT": 2,
              "ORDER_SQUARE_DEBIT_CARD": 3,
              "CREATE_ACH_TRANSFER": 4,
              "SCA_ACTION": 5,
              "SCA_VERIFICATION_ATTEMPT": 6
            }
          },
          "DenyCause": {
            "values": {
              "UNKNOWN": 0,
              "UNAUTHENTICATED": 1,
              "INSUFFICIENT_PERMISSIONS": 2,
              "INSUFFICIENT_AUTHENTICATION": 3,
              "SCA_ATTEMPTS_EXCEEDED_LIMIT": 4,
              "BLOCKED_BY_RISK": 5,
              "ACH_AMOUNT_EXCEEDED_LIMIT": 6
            }
          },
          "MerchantData": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "isMerchantOwner": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "paymentCount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "BankingData": {
            "fields": {
              "accountAgeDays": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "merchantOwnerToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "withdrawnAmount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "StepUpAuthData": {
            "fields": {
              "maxTwoFactorAgeAdjustmentMins": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CreateAchTransfer": {
            "fields": {
              "bankingData": {
                "type": "squareup.authz_engines.BankingData",
                "id": 2,
                "rule": "optional"
              },
              "merchantData": {
                "type": "squareup.authz_engines.MerchantData",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CreateSquareCheckingAccount": {
            "fields": {
              "kybStatus": {
                "type": "squareup.bbqualifier.service.VerificationStatus",
                "id": 1,
                "rule": "optional"
              },
              "requiresTwoFactorAuth": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "ineligibilityReasons": {
                "type": "squareup.bbqualifier.service.GetEligibilityResponse.FailedRequirement.Reason",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "OrderSquareDebitCard": {
            "fields": {
              "cardToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "personToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "shippingAddress": {
                "type": "squareup.common.location.GlobalAddress",
                "id": 3,
                "rule": "optional"
              },
              "balanceId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "LinkDebitCard": {
            "fields": {
              "stepUpAuthData": {
                "type": "squareup.authz_engines.StepUpAuthData",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "SCAVerificationAttempt": {
            "fields": {}
          },
          "RequestContext": {
            "fields": {
              "createAchTransfer": {
                "type": "squareup.authz_engines.CreateAchTransfer",
                "id": 1,
                "rule": "optional"
              },
              "createSquareCheckingAccount": {
                "type": "squareup.authz_engines.CreateSquareCheckingAccount",
                "id": 2,
                "rule": "optional"
              },
              "orderSquareDebitCard": {
                "type": "squareup.authz_engines.OrderSquareDebitCard",
                "id": 3,
                "rule": "optional"
              },
              "linkDebitCard": {
                "type": "squareup.authz_engines.LinkDebitCard",
                "id": 4,
                "rule": "optional"
              },
              "scaVerificationAttempt": {
                "type": "squareup.authz_engines.SCAVerificationAttempt",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "Reason": {
            "fields": {
              "message": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "obligation": {
                "type": "squareup.authz_engines.obligations.Obligation",
                "id": 2,
                "rule": "optional"
              },
              "denyCause": {
                "type": "squareup.authz_engines.DenyCause",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "AllowRequest": {
            "fields": {
              "action": {
                "type": "squareup.authz_engines.PolicyProtectedAction",
                "id": 1,
                "rule": "optional"
              },
              "requestContext": {
                "type": "squareup.authz_engines.RequestContext",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AllowResponse": {
            "fields": {
              "allow": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "reasons": {
                "type": "squareup.authz_engines.Reason",
                "id": 2,
                "rule": "repeated"
              },
              "errors": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 4,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.authz_engines?.nested?.PolicyProtectedAction && !$root.nested?.squareup?.nested?.authz_engines?.nested?.DenyCause && !$root.nested?.squareup?.nested?.authz_engines?.nested?.MerchantData && !$root.nested?.squareup?.nested?.authz_engines?.nested?.BankingData && !$root.nested?.squareup?.nested?.authz_engines?.nested?.StepUpAuthData && !$root.nested?.squareup?.nested?.authz_engines?.nested?.CreateAchTransfer && !$root.nested?.squareup?.nested?.authz_engines?.nested?.CreateSquareCheckingAccount && !$root.nested?.squareup?.nested?.authz_engines?.nested?.OrderSquareDebitCard && !$root.nested?.squareup?.nested?.authz_engines?.nested?.LinkDebitCard && !$root.nested?.squareup?.nested?.authz_engines?.nested?.SCAVerificationAttempt && !$root.nested?.squareup?.nested?.authz_engines?.nested?.RequestContext && !$root.nested?.squareup?.nested?.authz_engines?.nested?.Reason && !$root.nested?.squareup?.nested?.authz_engines?.nested?.AllowRequest && !$root.nested?.squareup?.nested?.authz_engines?.nested?.AllowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PolicyProtectedAction @ squareup/authz_engines/authz_engines_service.proto at 16:1
 */
export const PolicyProtectedAction = $root.lookupEnum('squareup.authz_engines.PolicyProtectedAction').values;
/**
 * SOURCE DenyCause @ squareup/authz_engines/authz_engines_service.proto at 28:1
 */
export const DenyCause = $root.lookupEnum('squareup.authz_engines.DenyCause').values;
/**
 * SOURCE MerchantData @ squareup/authz_engines/authz_engines_service.proto at 39:1
 */
export const MerchantData = $root.lookupType('squareup.authz_engines.MerchantData');
fixType(MerchantData);
Builder.createAndAttachToType(MerchantData);
/**
 * SOURCE BankingData @ squareup/authz_engines/authz_engines_service.proto at 45:1
 */
export const BankingData = $root.lookupType('squareup.authz_engines.BankingData');
fixType(BankingData);
Builder.createAndAttachToType(BankingData);
/**
 * SOURCE StepUpAuthData @ squareup/authz_engines/authz_engines_service.proto at 51:1
 */
export const StepUpAuthData = $root.lookupType('squareup.authz_engines.StepUpAuthData');
fixType(StepUpAuthData);
Builder.createAndAttachToType(StepUpAuthData);
/**
 * SOURCE CreateAchTransfer @ squareup/authz_engines/authz_engines_service.proto at 56:1
 */
export const CreateAchTransfer = $root.lookupType('squareup.authz_engines.CreateAchTransfer');
fixType(CreateAchTransfer);
Builder.createAndAttachToType(CreateAchTransfer);
/**
 * SOURCE CreateSquareCheckingAccount @ squareup/authz_engines/authz_engines_service.proto at 61:1
 */
export const CreateSquareCheckingAccount = $root.lookupType('squareup.authz_engines.CreateSquareCheckingAccount');
fixType(CreateSquareCheckingAccount);
Builder.createAndAttachToType(CreateSquareCheckingAccount);
/**
 * SOURCE OrderSquareDebitCard @ squareup/authz_engines/authz_engines_service.proto at 67:1
 */
export const OrderSquareDebitCard = $root.lookupType('squareup.authz_engines.OrderSquareDebitCard');
fixType(OrderSquareDebitCard, {
  cardToken: {
    required: true
  },
  personToken: {
    required: true
  },
  shippingAddress: {
    required: true
  },
  balanceId: {
    required: true
  },
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(OrderSquareDebitCard);
/**
 * SOURCE LinkDebitCard @ squareup/authz_engines/authz_engines_service.proto at 75:1
 */
export const LinkDebitCard = $root.lookupType('squareup.authz_engines.LinkDebitCard');
fixType(LinkDebitCard);
Builder.createAndAttachToType(LinkDebitCard);
/**
 * SOURCE SCAVerificationAttempt @ squareup/authz_engines/authz_engines_service.proto at 79:1
 */
export const SCAVerificationAttempt = $root.lookupType('squareup.authz_engines.SCAVerificationAttempt');
fixType(SCAVerificationAttempt);
Builder.createAndAttachToType(SCAVerificationAttempt);
/**
 * We want one top-level object that holds internal action-scoped objects. Even
 * in a world where we store common data in (or otherwise immediately accessible to) AuthzEngines,
 * there will likely always be some request contextual data used for evaluations that
 * make sense for the client to provide. Ideally as we get closer to that world, the size
 * and complexity of this request object shrinks.
 *
 * SOURCE RequestContext @ squareup/authz_engines/authz_engines_service.proto at 88:1
 */
export const RequestContext = $root.lookupType('squareup.authz_engines.RequestContext');
fixType(RequestContext);
Builder.createAndAttachToType(RequestContext);
/**
 * SOURCE Reason @ squareup/authz_engines/authz_engines_service.proto at 97:1
 */
export const Reason = $root.lookupType('squareup.authz_engines.Reason');
fixType(Reason);
Builder.createAndAttachToType(Reason);
/**
 * SOURCE AllowRequest @ squareup/authz_engines/authz_engines_service.proto at 108:1
 */
export const AllowRequest = $root.lookupType('squareup.authz_engines.AllowRequest');
fixType(AllowRequest);
Builder.createAndAttachToType(AllowRequest);
/**
 * SOURCE AllowResponse @ squareup/authz_engines/authz_engines_service.proto at 113:1
 */
export const AllowResponse = $root.lookupType('squareup.authz_engines.AllowResponse');
fixType(AllowResponse);
Builder.createAndAttachToType(AllowResponse);